import { render, staticRenderFns } from "./Brand_Story.vue?vue&type=template&id=2dd8ef88&scoped=true"
import script from "./Brand_Story.vue?vue&type=script&lang=js"
export * from "./Brand_Story.vue?vue&type=script&lang=js"
import style0 from "./Brand_Story.vue?vue&type=style&index=0&id=2dd8ef88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8ef88",
  null
  
)

export default component.exports